// src/utils/useOnline.ts
import { useEffect, useState } from "react";

/**
 * Hlásí prohlížeč připojení k síti? navigator.onLine + události online /
 * offline (stejný zdroj jako offline pruh AppShellu). Mimo prohlížeč true.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === "undefined" ? true : navigator.onLine
  );
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    // Stav se mohl změnit mezi prvním vykreslením a připojením posluchačů
    setOnline(navigator.onLine);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);
  return online;
}
